import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { AutoLotView, JupiterLotDataInspection } from 'src/app/const';

import { JupiterInspectionInfo } from './types/jupiter-inspection-info.type';

@Component({
  selector: 'app-lot-moto-jupiter-data',
  templateUrl: './lot-moto-jupiter-data.component.html',
  styleUrls: ['./lot-moto-jupiter-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotMotoJupiterDataComponent implements OnChanges {
  @Input()
  set lot(lot: AutoLotView) {
    this.inspection = lot.jupiterLotData?.inspections;
    this.comment = lot.jupiterLotData?.bds_comment;
    this.images360 = lot.jupiterLotData?.images_360;
    this.inspectionInfos = Object.entries(this.inspection || {}).map(
      ([title, value]) =>
        <JupiterInspectionInfo>{
          title,
          images: value.images || [],
          notes: value.notes || {},
          score: value.score || '',
        },
    );
  }

  @HostBinding('style.display') display: 'none' | 'block' = 'none';

  comment?: string;
  inspection?: Record<string, JupiterLotDataInspection>;
  inspectionInfos: JupiterInspectionInfo[];
  renderNoSomeDataAlert = false;
  images360?: string[];

  private get hasInspection(): boolean {
    return !!Object.keys(this.inspection || {}).length;
  }

  inspectionInfoIdentity(_: number, inspectionInfo: JupiterInspectionInfo): string {
    return inspectionInfo.title;
  }

  noData(inspectionInfo: JupiterInspectionInfo): void {
    this.renderNoSomeDataAlert = true;
    this.inspectionInfos = this.inspectionInfos.filter(
      (info) => info.title !== inspectionInfo.title,
    );
  }

  ngOnChanges(): void {
    this.display = this.hasInspection ? 'block' : 'none';
  }
}
